import { render, staticRenderFns } from "./CollectorInsert.vue?vue&type=template&id=4927cebd&scoped=true&"
import script from "./CollectorInsert.vue?vue&type=script&lang=js&"
export * from "./CollectorInsert.vue?vue&type=script&lang=js&"
import style0 from "./CollectorInsert.vue?vue&type=style&index=0&id=4927cebd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4927cebd",
  null
  
)

export default component.exports